import { ReportType } from "../reportype";

export class TaxSearchReportRequest {
    public userName: string;
    public collectionId: number;
    public taxId: string;
    public taxName: string;
    public reportType: ReportType;
}
